import { render } from "./PlanilhasFinanceiro.vue?vue&type=template&id=6d1ae5d6"
import script from "./PlanilhasFinanceiro.vue?vue&type=script&lang=js"
export * from "./PlanilhasFinanceiro.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__